// extracted by mini-css-extract-plugin
module.exports = {"genericButton":"GenericButton_genericButton__1gp-_","icon":"GenericButton_icon__3C5_j","baseline":"GenericButton_baseline__1QOWR","buttonText":"GenericButton_buttonText__30sKs"};